import { useMemo } from 'react'

import { useLineChart } from './use-line-chart'

interface Props {
  dataKeys: string[]
}

export const LineChartDropLine: React.FC<Props> = ({ dataKeys }) => {
  const { activeIndex, dataSets, xScale, yScale, plotAreaHeight, plotAreaPadding } = useLineChart()

  const point = useMemo(() => {
    if (activeIndex === null) {
      return null
    }

    const dataSets_ = dataKeys.map((dataKey) => {
      return dataSets[dataKey]
    })
    const points = dataSets_.map((dataSet) => {
      const data = dataSet?.[activeIndex] ?? null
      const x = xScale(activeIndex)
      const y = data === null ? null : yScale(data)

      return { x, y }
    })
    const validPoints = points.filter((point): point is { x: number; y: number } => {
      return point.y !== null
    })
    const highestPoint = validPoints.reduce((accum, current) => {
      return accum.y === null || current.y === null ? accum : current.y < accum.y ? current : accum
    }, validPoints[0])

    if (!highestPoint) {
      return null
    }

    return highestPoint
  }, [activeIndex, dataKeys, dataSets, xScale, yScale])

  if (point === null) {
    return null
  }

  return (
    <g transform={`translate(${point.x}, ${point.y})`}>
      <line
        x1={0}
        y1={0}
        x2={0}
        y2={plotAreaHeight + (plotAreaPadding?.top ?? 0) - point.y}
        stroke="hsla(215, 20%, 65%, 1)"
        strokeWidth={1}
      />
    </g>
  )
}
